import { defineComponent as g, computed as b, createBlock as s, openBlock as r, withCtx as y, createVNode as i, createElementBlock as o, createCommentVNode as t, unref as a, normalizeClass as _, createElementVNode as h, toDisplayString as l } from "vue";
import { RevButtonIcon as k } from "@ds/components/ButtonIcon";
import v from "../../../icons/generated/IconCross.vue2.js";
import w from "../../../icons/generated/IconWarning.vue2.js";
import { tw as m } from "../../../utils/tailwind.js";
import B from "./DocumentLabelWrapper.vue2.js";
import C from "./DocumentName.vue2.js";
const M = { class: "flex" }, $ = {
  key: 0,
  class: "text-static-danger-hi caption-bold truncate"
}, E = {
  key: 1,
  class: "text-static-danger-hi grow truncate py-8"
}, R = /* @__PURE__ */ g({
  name: "DocumentError",
  __name: "DocumentError",
  props: {
    name: {},
    errorMessage: {},
    deletable: { type: Boolean },
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(c, { emit: d }) {
    const u = c, p = d, f = b(() => [
      m`ml-0 mr-auto overflow-hidden`,
      !u.errorMessage && m`py-8`
    ]);
    return (e, n) => (r(), s(B, { class: "border-static-danger-hi flex w-full grow items-center justify-between border" }, {
      default: y(() => [
        i(a(w), { class: "text-static-danger-hi" }),
        e.name ? (r(), o("div", {
          key: 0,
          class: _(f.value)
        }, [
          h("div", M, [
            i(C, { name: e.name }, null, 8, ["name"])
          ]),
          e.errorMessage ? (r(), o("div", $, l(e.errorMessage), 1)) : t("", !0)
        ], 2)) : t("", !0),
        !e.name && e.errorMessage ? (r(), o("span", E, l(e.errorMessage), 1)) : t("", !0),
        e.deletable ? (r(), s(a(k), {
          key: 2,
          "aria-label": e.deleteButtonAriaLabel,
          icon: a(v),
          variant: "secondary",
          onClick: n[0] || (n[0] = (N) => p("delete"))
        }, null, 8, ["aria-label", "icon"])) : t("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  R as default
};
